export default {
	headers: {
		general: {
			patient: "Patient",
			options: "Options",
			attach: "Attacher",
			alert_history: "Histoire d'alerte",
			resume: "Résumé",
			readings: "Lectures",
			notifications: "Notifications",
			report: "Rapport",
			reports: "Rapports",
			attach_device: "Attacher un appareil",
			reading: "Lecture",
			position: "Position",
			zone: "Zone",
			pillbox: "Boîte à pilules",
			add_pill: "Ajouter Comprimé",
			edit_pill: "Modifier Comprimé",
			healthreports: "Rapports de santé",
			medicaldocuments: "Documents médicaux",
			edit_configs: "Modifier les configurations",
			history: "Histoire",
			response: "Réponse",
		}
	}
}



// WEBPACK FOOTER //
// ./src/i18n/headers/headers_fr.js